<template>
  <div class="flex flex-col w-full h-full mx-auto px-4 py-4 overflow-auto">
    <div class="w-full">
      <button
        @click="historyGraph = 'fechas'; filterAlertsData('');"
        class="w-1/2 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border border-secondary-color-dark hover:border-transparent rounded uppercase"
        v-bind:class="[
            AlertCharts === true
              ? 'border-transparent bg-secondary-color text-white'
              : 'bg-white text-secondary-color-dark'
          ]"
      >Alertas</button>
      <button
        @click="historyGraph = 'fechas'; getComplaintsData()"
        class="w-1/2 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border border-secondary-color-dark hover:border-transparent rounded uppercase"
        v-bind:class="[
            ComplaintCharts === true
              ? 'border-transparent bg-secondary-color text-white'
              : 'bg-white text-secondary-color-dark'
          ]"
      >Denuncias</button>
    </div>
    <div class="flex flex-col md:flex-row w-full mt-4 p-4 bg-white rounded-lg shadow-lg">
      <div class="flex w-full md:w-8/12 border-r-2">
        <div class="w-full md:w-2/6">
          <label
            class="block uppercase tracking-wide text-gray-700 font-bold mb-2 text-left"
            for="desde"
          >Desde</label>
          <input
            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-2 leading-tight focus:outline-none focus:bg-white"
            id="desde"
            type="date"
            name="desde"
            v-model="desde"
          />
        </div>
        <div class="w-full ml-0 md:ml-2 md:w-2/6">
          <label
            class="block uppercase tracking-wide text-gray-700 font-bold mb-2 text-left"
            for="hasta"
          >Hasta</label>
          <input
            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-2 leading-tight focus:outline-none focus:bg-white"
            id="hasta"
            type="date"
            name="hasta"
            v-model="hasta"
          />
        </div>
        <div class="w-full md:w-2/6">
          <button
            v-if="AlertCharts"
            class="bg-secondary-color hover:bg-secondary-color-dark px-2 py-2 text-center rounded-lg text-white font-bold tracking-wide"
            v-on:click="filterAlertsData(selected)"
          >Buscar</button>

          <button
            v-if="AlertCharts"
            class="mt-4 mx-2 px-2 py-2 bg-tertiary-color hover:bg-tertiary-color-dark rounded-lg text-white font-bold shadow-lg"
          >
            <button
              v-on:click="startDownloadAlerts()"
              class="font-semibold"
            >Descargar</button>
          </button>

          <button
            v-if="ComplaintCharts"
            class="bg-secondary-color hover:bg-secondary-color-dark px-2 py-2 text-center rounded-lg text-white font-bold tracking-wide"
            v-on:click="getComplaintsData()"
          >Buscar</button>

          <button
            v-if="ComplaintCharts"
            class="mt-4 mx-2 px-2 py-2 bg-tertiary-color hover:bg-tertiary-color-dark rounded-lg text-white font-bold shadow-lg"
          >
            <download-excel
              :before-generate = "startDownloadComplaint"
              :data="downloadComplaints"
              :fields="json_fields_complaints"
              name="Denuncias.xls"
            >Descargar</download-excel>
          </button>
        </div>
      </div>
      <div class="flex w-full md:w-4/12">
        <div class="flex flex-col w-full md:w-6/12 pl-4">
          <div class="w-full text-sm">
            <span class="font-bold uppercase text-gray-700">
              Total de {{text}}:
              <span class="font-extrabold text-gray-900">{{ info }}</span>
            </span>
          </div>
          <div class="w-full text-sm">
            <span class="font-bold uppercase text-gray-700">{{text}} POR SEXO:</span>
            <div class="flex items-center justify-center">
              <span class="flex items-center font-bold text-xl">
                <span>{{ hombres }}%</span>
                <svg class="h-8 w-6" viewBox="0 0 30 30">
                  <path
                    fill="#000000"
                    d="M12,2A2,2 0 0,1 14,4A2,2 0 0,1 12,6A2,2 0 0,1 10,4A2,2 0 0,1 12,2M10.5,7H13.5A2,2 0 0,1 15.5,9V14.5H14V22H10V14.5H8.5V9A2,2 0 0,1 10.5,7Z"
                  />
                </svg>
              </span>
              <span class="flex items-center font-bold text-xl">
                <span>{{ mujeres }}%</span>
                <svg class="h-8 w-6" viewBox="0 0 30 30">
                  <path
                    fill="#000000"
                    d="M12,2A2,2 0 0,1 14,4A2,2 0 0,1 12,6A2,2 0 0,1 10,4A2,2 0 0,1 12,2M10.5,22V16H7.5L10.09,8.41C10.34,7.59 11.1,7 12,7C12.9,7 13.66,7.59 13.91,8.41L16.5,16H13.5V22H10.5Z"
                  />
                </svg>
              </span>
            </div>
          </div>
        </div>
        <div class="flex flex-col items-center justify-center w-full md:w-6/12">
          <span class="font-bold text-center uppercase text-gray-600">TIPO</span>
          <div class="w-full relative" v-if="AlertCharts">
            <span class="font-bold font-bold text-xl">Alerta General</span>
            <!-- <select
              @change="filterAlertsData(selected)"
              class="block appearance-none w-full bg-gray-200 border border-gray-300 text-gray-700 py-2 px-2 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              v-model="selected"
            >
              <option value>VER TODO</option>
              <option
                v-for="tipo in AlertCategorys"
                v-bind:key="tipo"
                v-bind:value="tipo"
              >{{ tipo }}</option>
            </select> 
             <div
              class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>-->
          </div>
          <div class="w-full relative" v-if="ComplaintCharts">
            <select
              @change="filterComplaintsData(selected)"
              class="block appearance-none w-full bg-gray-200 border border-gray-300 text-gray-700 py-2 px-2 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              v-model="selected"
            >
              <option value>VER TODO</option>
              <option
                v-for="tipo in ComplaintCategorys"
                v-bind:key="tipo[0]"
                v-bind:value="tipo[0]"
              >{{ tipo[1] }}</option>
            </select>
            <div
              class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex w-full h-full">
      <div class="w-1/2 h-full pt-4">
        <div class="w-full h-full bg-white shadow-lg rounded-lg p-4">
          <div class="flex items-center w-full">
            <div class="w-1/5">
              <span class="uppercase">Por estado</span>
            </div>
            <div class="w-3/5">
              <div v-if="AlertCharts">
                <button
                  @click="autoridadesGraph=true; change_table()"
                  class="w-1/2 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border border-secondary-color-dark hover:border-transparent rounded"
                  v-bind:class="[Autoridades === true ? 'border-transparent bg-secondary-color text-white' : 'bg-transparent text-secondary-color-dark']"
                >AUTORIDADES</button>
                <button
                  @click="autoridadesGraph=false; change_table()"
                  class="w-1/2 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border border-secondary-color-dark hover:border-transparent rounded"
                  v-bind:class="[Autoridades === false ? 'border-transparent bg-secondary-color text-white' : 'bg-transparent text-secondary-color-dark']"
                >VISITANTES</button>
              </div>
            </div>
            <div class="w-1/5 flex justify-end">
              <div class="relative group border-solid border-2 rounded-md">
                <div class="flex items-center px-2 py-2 cursor-pointer">
                  <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                    <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                      <path
                        fill="currentColor"
                        d="M15.9,18.45C17.25,18.45 18.35,17.35 18.35,16C18.35,14.65 17.25,13.55 15.9,13.55C14.54,13.55 13.45,14.65 13.45,16C13.45,17.35 14.54,18.45 15.9,18.45M21.1,16.68L22.58,17.84C22.71,17.95 22.75,18.13 22.66,18.29L21.26,20.71C21.17,20.86 21,20.92 20.83,20.86L19.09,20.16C18.73,20.44 18.33,20.67 17.91,20.85L17.64,22.7C17.62,22.87 17.47,23 17.3,23H14.5C14.32,23 14.18,22.87 14.15,22.7L13.89,20.85C13.46,20.67 13.07,20.44 12.71,20.16L10.96,20.86C10.81,20.92 10.62,20.86 10.54,20.71L9.14,18.29C9.05,18.13 9.09,17.95 9.22,17.84L10.7,16.68L10.65,16L10.7,15.31L9.22,14.16C9.09,14.05 9.05,13.86 9.14,13.71L10.54,11.29C10.62,11.13 10.81,11.07 10.96,11.13L12.71,11.84C13.07,11.56 13.46,11.32 13.89,11.15L14.15,9.29C14.18,9.13 14.32,9 14.5,9H17.3C17.47,9 17.62,9.13 17.64,9.29L17.91,11.15C18.33,11.32 18.73,11.56 19.09,11.84L20.83,11.13C21,11.07 21.17,11.13 21.26,11.29L22.66,13.71C22.75,13.86 22.71,14.05 22.58,14.16L21.1,15.31L21.15,16L21.1,16.68M6.69,8.07C7.56,8.07 8.26,7.37 8.26,6.5C8.26,5.63 7.56,4.92 6.69,4.92A1.58,1.58 0 0,0 5.11,6.5C5.11,7.37 5.82,8.07 6.69,8.07M10.03,6.94L11,7.68C11.07,7.75 11.09,7.87 11.03,7.97L10.13,9.53C10.08,9.63 9.96,9.67 9.86,9.63L8.74,9.18L8,9.62L7.81,10.81C7.79,10.92 7.7,11 7.59,11H5.79C5.67,11 5.58,10.92 5.56,10.81L5.4,9.62L4.64,9.18L3.5,9.63C3.41,9.67 3.3,9.63 3.24,9.53L2.34,7.97C2.28,7.87 2.31,7.75 2.39,7.68L3.34,6.94L3.31,6.5L3.34,6.06L2.39,5.32C2.31,5.25 2.28,5.13 2.34,5.03L3.24,3.47C3.3,3.37 3.41,3.33 3.5,3.37L4.63,3.82L5.4,3.38L5.56,2.19C5.58,2.08 5.67,2 5.79,2H7.59C7.7,2 7.79,2.08 7.81,2.19L8,3.38L8.74,3.82L9.86,3.37C9.96,3.33 10.08,3.37 10.13,3.47L11.03,5.03C11.09,5.13 11.07,5.25 11,5.32L10.03,6.06L10.06,6.5L10.03,6.94Z"
                      />
                    </svg>
                  </svg>
                </div>

                <div
                  class="absolute right-0 mt-0 py-2 w-48 bg-white rounded-lg shadow-xl text-left hidden group-hover:block"
                >
                  <a class="flex items-center justify-center px-4 py-2 text-gray-800">
                    <span class="font-bold">Gráficas por:</span>
                  </a>
                  <a
                    v-bind:class="[historyGraph=='fechas' ? 'bg-secondary-color text-white': 'text-gray-800']"
                    v-if="AlertCharts"
                    v-on:click="historyGraph='fechas'; change_table()"
                    href="#"
                    class="flex items-center justify-center px-4 py-2 hover:bg-secondary-color hover:text-white"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                      width="24"
                    >
                      <path d="M0 0h24v24H0z" fill="none" />
                      <path
                        d="M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
                      />
                    </svg>
                    <span class="font-bold">Fechas</span>
                  </a>
                  <a
                    v-bind:class="[historyGraph=='dias' ? 'bg-secondary-color text-white': 'text-gray-800']"
                    v-if="AlertCharts"
                    v-on:click="historyGraph='dias'; change_table()"
                    href="#"
                    class="flex items-center justify-center px-4 py-2 hover:bg-secondary-color hover:text-white"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                      width="24"
                    >
                      <path d="M0 0h24v24H0z" fill="none" />
                      <path
                        d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
                      />
                    </svg>
                    <span class="font-bold">Días</span>
                  </a>
                  <a
                    v-bind:class="[historyGraph!='dias' && historyGraph!='fechas' ? 'bg-secondary-color text-white': 'text-gray-800']"
                    v-if="AlertCharts"
                    v-on:click = "showByday = !showByday"
                    href="#"
                    class="flex items-center justify-center px-4 py-2 hover:bg-secondary-color hover:text-white"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                      width="24"
                    >
                      <path d="M0 0h24v24H0z" fill="none" />
                      <path
                        d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
                      />
                    </svg>
                    <span class="font-bold">Horas</span>
                    <svg
                      v-if="!showByday"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                      width="24"
                    >
                      <path d="M0 0h24v24H0z" fill="none" />
                      <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
                    </svg>
                    <svg
                      v-if="showByday"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                      width="24"
                    >
                      <path d="M0 0h24v24H0z" fill="none" />
                      <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>
                    </svg>
                  </a>
                  <!-- class="right-0 mt-0 py-2 w-48 bg-white rounded-lg shadow-xl text-left hidden group-hover:block" -->
                  <div
                    v-if="showByday"
                  >
                    <a
                      v-bind:class="[historyGraph=='Lunes' ? 'bg-secondary-color text-white': 'text-gray-800']"
                      v-if="AlertCharts"
                      v-on:click="historyGraph='Lunes'; change_table()"
                      href="#"
                      class="flex items-center justify-center px-4 py-2 hover:bg-secondary-color hover:text-white"
                    >
                      <span class="font-bold">Lunes</span>
                    </a>
                    <a
                      v-bind:class="[historyGraph =='Martes' ? 'bg-secondary-color text-white': 'text-gray-800']"
                      v-if="AlertCharts"
                      v-on:click="historyGraph='Martes'; change_table()"
                      href="#"
                      class="flex items-center justify-center px-4 py-2 hover:bg-secondary-color hover:text-white"
                    >
                      <span class="font-bold">Martes</span>
                    </a>
                    <a
                      v-bind:class="[historyGraph =='Miercoles' ? 'bg-secondary-color text-white': 'text-gray-800']"
                      v-if="AlertCharts"
                      v-on:click="historyGraph='Miercoles'; change_table()"
                      href="#"
                      class="flex items-center justify-center px-4 py-2 hover:bg-secondary-color hover:text-white"
                    >
                      <span class="font-bold">Miércoles</span>
                    </a>
                    <a
                      v-bind:class="[historyGraph == 'Jueves' ? 'bg-secondary-color text-white': 'text-gray-800']"
                      v-if="AlertCharts"
                      v-on:click="historyGraph='Jueves'; change_table()"
                      href="#"
                      class="flex items-center justify-center px-4 py-2 hover:bg-secondary-color hover:text-white"
                    >
                      <span class="font-bold">Jueves</span>
                    </a>
                    <a
                      v-bind:class="[historyGraph == 'Viernes' ? 'bg-secondary-color text-white': 'text-gray-800']"
                      v-if="AlertCharts"
                      v-on:click="historyGraph='Viernes'; change_table()"
                      href="#"
                      class="flex items-center justify-center px-4 py-2 hover:bg-secondary-color hover:text-white"
                    >
                      <span class="font-bold">Viernes</span>
                    </a>
                    <a
                      v-bind:class="[historyGraph=='Sabado' ? 'bg-secondary-color text-white': 'text-gray-800']"
                      v-if="AlertCharts"
                      v-on:click="historyGraph='Sabado'; change_table()"
                      href="#"
                      class="flex items-center justify-center px-4 py-2 hover:bg-secondary-color hover:text-white"
                    >
                      <span class="font-bold">Sábado</span>
                    </a>
                    <a
                      v-bind:class="[historyGraph=='Domingo' ? 'bg-secondary-color text-white': 'text-gray-800']"
                      v-if="AlertCharts"
                      v-on:click="historyGraph='Domingo'; change_table()"
                      href="#"
                      class="flex items-center justify-center px-4 py-2 hover:bg-secondary-color hover:text-white"
                    >
                      <span class="font-bold">Domingo</span>
                    </a>
                  </div>
                  <a
                    v-bind:class="[historyGraph=='fechas' ? 'bg-secondary-color text-white': 'text-gray-800']"
                    v-if="ComplaintCharts"
                    v-on:click="historyGraph='fechas'; getComplaintsData()"
                    href="#"
                    class="flex items-center justify-center px-4 py-2 hover:bg-secondary-color hover:text-white"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                      width="24"
                    >
                      <path d="M0 0h24v24H0V0z" fill="none" />
                      <path
                        d="M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
                      />
                    </svg>
                    <span class="font-bold">Fechas</span>
                  </a>
                  <a
                    v-bind:class="[historyGraph=='dias' ? 'bg-secondary-color text-white': 'text-gray-800']"
                    v-if="ComplaintCharts"
                    v-on:click="historyGraph='dias'; getComplaintsData()"
                    href="#"
                    class="flex items-center justify-center px-4 py-2 hover:bg-secondary-color hover:text-white"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                      width="24"
                    >
                      <path d="M0 0h24v24H0V0z" fill="none" />
                      <path
                        d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
                      />
                    </svg>
                    <span class="font-bold">Días</span>
                  </a>
                  <a
                    v-bind:class="[historyGraph!='dias' && historyGraph!='fechas' ? 'bg-secondary-color text-white': 'text-gray-800']"
                    v-if="ComplaintCharts"
                    v-on:click = "showByday = !showByday"
                    href="#"
                    class="flex items-center justify-center px-4 py-2 hover:bg-secondary-color hover:text-white"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                      width="24"
                    >
                      <path d="M0 0h24v24H0z" fill="none" />
                      <path
                        d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
                      />
                    </svg>
                    <span class="font-bold">Horas</span>
                    <svg
                      v-if="!showByday"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                      width="24"
                    >
                      <path d="M0 0h24v24H0z" fill="none" />
                      <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
                    </svg>
                    <svg
                      v-if="showByday"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                      width="24"
                    >
                      <path d="M0 0h24v24H0z" fill="none" />
                      <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>
                    </svg>
                  </a>
                  <div
                    v-if="showByday"
                  >
                    <a
                      v-bind:class="[historyGraph=='Lunes' ? 'bg-secondary-color text-white': 'text-gray-800']"
                      v-if="ComplaintCharts"
                      v-on:click="historyGraph='Lunes'; getComplaintsData()"
                      href="#"
                      class="flex items-center justify-center px-4 py-2 hover:bg-secondary-color hover:text-white"
                    >
                      <span class="font-bold">Lunes</span>
                    </a>
                    <a
                      v-bind:class="[historyGraph=='Martes' ? 'bg-secondary-color text-white': 'text-gray-800']"
                      v-if="ComplaintCharts"
                      v-on:click="historyGraph='Martes'; getComplaintsData()"
                      href="#"
                      class="flex items-center justify-center px-4 py-2 hover:bg-secondary-color hover:text-white"
                    >
                      <span class="font-bold">Martes</span>
                    </a>
                    <a
                      v-bind:class="[historyGraph=='Miercoles' ? 'bg-secondary-color text-white': 'text-gray-800']"
                      v-if="ComplaintCharts"
                      v-on:click="historyGraph='Miercoles'; getComplaintsData()"
                      href="#"
                      class="flex items-center justify-center px-4 py-2 hover:bg-secondary-color hover:text-white"
                    >
                      <span class="font-bold">Miércoles</span>
                    </a>
                    <a
                      v-bind:class="[historyGraph=='Jueves' ? 'bg-secondary-color text-white': 'text-gray-800']"
                      v-if="ComplaintCharts"
                      v-on:click="historyGraph='Jueves'; getComplaintsData()"
                      href="#"
                      class="flex items-center justify-center px-4 py-2 hover:bg-secondary-color hover:text-white"
                    >
                      <span class="font-bold">Jueves</span>
                    </a>
                    <a
                      v-bind:class="[historyGraph=='Viernes' ? 'bg-secondary-color text-white': 'text-gray-800']"
                      v-if="ComplaintCharts"
                      v-on:click="historyGraph='Viernes'; getComplaintsData()"
                      href="#"
                      class="flex items-center justify-center px-4 py-2 hover:bg-secondary-color hover:text-white"
                    >
                      <span class="font-bold">Viernes</span>
                    </a>
                    <a
                      v-bind:class="[historyGraph=='Sabado' ? 'bg-secondary-color text-white': 'text-gray-800']"
                      v-if="ComplaintCharts"
                      v-on:click="historyGraph='Sabado'; getComplaintsData()"
                      href="#"
                      class="flex items-center justify-center px-4 py-2 hover:bg-secondary-color hover:text-white"
                    >
                      <span class="font-bold">Sábado</span>
                    </a>
                    <a
                      v-bind:class="[historyGraph=='Domingo' ? 'bg-secondary-color text-white': 'text-gray-800']"
                      v-if="ComplaintCharts"
                      v-on:click="historyGraph='Domingo'; getComplaintsData()"
                      href="#"
                      class="flex items-center justify-center px-4 py-2 hover:bg-secondary-color hover:text-white"
                    >
                      <span class="font-bold">Domingo</span>
                    </a>
                  </div>
                  <a class="flex items-center justify-center px-4 py-2 text-gray-800">
                    <span class="font-bold">Tipos de Gráficas</span>
                  </a>
                  <a
                    v-bind:class="[graficas[0].value ? 'bg-secondary-color text-white': 'text-gray-800']"
                    v-on:click="change_chart('lineas')"
                    href="#"
                    class="flex items-center justify-center px-4 py-2 hover:bg-secondary-color hover:text-white"
                  >
                    <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                      <path
                        fill="currentColor"
                        d="M9.96,11.31C10.82,8.1 11.5,6 13,6C14.5,6 15.18,8.1 16.04,11.31C17,14.92 18.1,19 22,19V17C19.8,17 19,14.54 17.97,10.8C17.08,7.46 16.15,4 13,4C9.85,4 8.92,7.46 8.03,10.8C7.03,14.54 6.2,17 4,17V2H2V22H22V20H4V19C7.9,19 9,14.92 9.96,11.31Z"
                      />
                    </svg>
                    <span class="font-bold">Líneas</span>
                  </a>

                  <a
                    v-bind:class="[graficas[1].value ? 'bg-secondary-color text-white': 'text-gray-800']"
                    v-on:click="change_chart('barras')"
                    href="#"
                    class="flex items-center justify-center px-4 py-2 hover:bg-secondary-color hover:text-white"
                  >
                    <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                      <path
                        fill="currentColor"
                        d="M22,21H2V3H4V19H6V10H10V19H12V6H16V19H18V14H22V21Z"
                      />
                    </svg>
                    <span class="ml-2 font-bold">Barras</span>
                  </a>

                  <a
                    v-bind:class="[graficas[3].value ? 'bg-secondary-color text-white': 'text-gray-800']"
                    v-on:click="change_chart('radar')"
                    href="#"
                    class="flex items-center justify-center px-4 py-2 hover:bg-secondary-color hover:text-white"
                  >
                    <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                      <path
                        fill="currentColor"
                        d="M19.07,4.93L17.66,6.34C19.1,7.79 20,9.79 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12C4,7.92 7.05,4.56 11,4.07V6.09C8.16,6.57 6,9.03 6,12A6,6 0 0,0 12,18A6,6 0 0,0 18,12C18,10.34 17.33,8.84 16.24,7.76L14.83,9.17C15.55,9.9 16,10.9 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12C8,10.14 9.28,8.59 11,8.14V10.28C10.4,10.63 10,11.26 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12C14,11.26 13.6,10.62 13,10.28V2H12A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,9.24 20.88,6.74 19.07,4.93Z"
                      />
                    </svg>
                    <span class="ml-2 font-bold">Radar</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <LineChart v-if="graficas[0].value" :chartData="datacollection" :options="optionsLinear" class="w-9/12 mx-auto"></LineChart>
          <BarChart
            v-if="graficas[1].value"
            :chartData="datacollection"
            :options="options"
            class="w-9/12 mx-auto"
          ></BarChart>
          <PieChart v-if="graficas[2].value" :chartData="datacollection" class="w-9/12 mx-auto"></PieChart>
          <RadarChart v-if="graficas[3].value" :chartData="datacollection" class="w-9/12 mx-auto"></RadarChart>
        </div>
      </div>
      <div class="w-1/2 h-full pt-4 pl-4">
        <div class="w-full bg-white shadow-lg rounded-lg px-2 py-2">
          <div class="flex justify-between items-center">
            <h4 class="text-center">POR EDAD</h4>
          </div>
          <BarChart :chartData="datacollection2" :width="100" :height="37"></BarChart>
        </div>
        <div class="w-full bg-white shadow-lg rounded-lg px-2 py-2 mt-4">
          <div class="flex justify-between items-center">
            <h4 class="text-center">POR NIVEL DE ESTUDIOS</h4>
          </div>
          <BarChart :chartData="datacollection3" :width="100" :height="37"></BarChart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LineChart from "./LineChart";
import BarChart from "./BarChart";
import PieChart from "./PieChart";
import RadarChart from "./RadarChart";
import moment from "moment";
import XLSX from 'xlsx';

export default {
  components: {
    RadarChart,
    PieChart,
    BarChart,
    LineChart
  },
  name: "reports",
  data() {
    return {
      showByday: false,
      stringDay: {
        0: "Domingo",
        1: "Lunes",
        2: "Martes",
        3: "Miercoles",
        4: "Jueves",
        5: "Viernes",
        6: "Sabado"
      },
      json_fields_alerts: {
        "Tipo de alerta": "tipo",
        Estado: "status",
        Sexo: "sex",
        Edad: "age",
        "Nivel de estudios": "nivel_estudios",
        Fecha: {
          field: "fecha_alerta",
          callback: value => {
            return moment(value).format("DD/MM/YYYY hh:mm A");
          }
        }
      },
      json_fields_complaints: {
        "Tipo de denuncia": "tipo",
        Categoria: "status",
        Sexo: "sex",
        Edad: "age",
        "Nivel de estudios": "nivel_estudios",
        Fecha: {
          field: "fecha_alerta",
          callback: value => {
            return moment(value).format("DD/MM/YYYY hh:mm A");
          }
        }
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      options: {
        scales: {
          xAxes: [
            {
              stacked: true,
              categoryPercentage: 0.5,
              barPercentage: 1,
              scaleLabel: { 
                display: true, 
                labelString: '' 
              } 
            }
          ],
          yAxes: [
            {
              stacked: true,
              scaleLabel: { 
                display: true, 
                labelString: '' 
              } 
            }
          ]
        }
      },
      optionsLinear: {
        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: '',
              }
            }
          ],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: '',
              }
            }
          ]
        }
      },
      AlertCharts: true,
      ComplaintCharts: false,
      graficas: [
        {
          type: "lineas",
          value: true
        },
        {
          type: "barras",
          value: false
        },
        {
          type: "pastel",
          value: false
        },
        {
          type: "radar",
          value: false
        }
      ],
      datasets: [],
      etiquetas: [],
      abiertas: [],
      asignadas: [],
      atendidas: [],

      //historyGraph: true,
      historyGraph: 'fechas',
      autoridadesGraph: true,
      etiquetasByDay: [
        "Domingo",
        "Lunes",
        "Martes",
        "Miercoles",
        "Jueves",
        "Viernes",
        "Sabado"
      ],
      abiertasByDay: [],
      asignadasByDay: [],
      atendidasByDay: [],
      InfraestructuraByDay: [],
      ambienteByDay: [],
      MovilidadByDay: [],
      civilByDay: [],
      RecreacionByDay: [],
      SaludByDay: [],
      SeguridadByDay: [],
      selected: "",

      abiertasByHours: new Array(24),
      asignadasByHours: new Array(24),
      atendidasByHours: new Array(24),
      InfraestructuraByHours: new Array(24),
      ambienteByHours: new Array(24),
      MovilidadByHours: new Array(24),
      civilByHours: new Array(24),
      RecreacionByHours: new Array(24),
      SaludByHours: new Array(24),
      SeguridadByHours: new Array(24),

      Infraestructura: [],
      ambiente: [],
      Movilidad: [],
      civil: [],
      Recreacion: [],
      Salud: [],
      Seguridad: [],

      filtro_tipo: [],

      hasta: new Date().toJSON().slice(0, 10),
      desde: new Date(new Date() - 1000 * 60 * 60 * 24 * 6)
        .toJSON()
        .slice(0, 10),

      datacollection: {},
      datacollection2: {},
      datacollection3: {},

      data2: {},
      data3: {},

      Autoridades: true,

      info: 0,
      respuesta: null,
      downloadAlerts: [],
      downloadComplaints: [],
      AlertCategorys: [],
      ComplaintCategorys: [],
      hombres: 0,
      mujeres: 0,
      h: 0,
      m: 0,

      text: "Alertas",
      arrayAge: [0, 0, 0, 0, 0, 0, 0],

      complaintCategories: null,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      }
    };
  },
  mounted() {
    this.getAlertTypes();
    this.getComplaintsType();
    //this.getAlertsData();
    this.filterAlertsData("");
    this.fetchComplaintCategories()
  },
  methods: {
    updateOptionChart(){
      switch (this.historyGraph){
        case 'fechas':
          this.optionsLinear.scales.xAxes[0].scaleLabel.labelString = 'Fechas'
          this.options.scales.xAxes[0].scaleLabel.labelString = 'Fechas'
          break;
        case 'dias':
          this.optionsLinear.scales.xAxes[0].scaleLabel.labelString = 'Dias'
          this.options.scales.xAxes[0].scaleLabel.labelString = 'Dias'
          break;
        case 'Lunes':
        case 'Martes':
        case 'Miercoles':
        case 'Jueves':
        case 'Viernes':
        case 'Sabado':
        case 'Domingo':
          this.optionsLinear.scales.xAxes[0].scaleLabel.labelString = 'Horas'
          this.options.scales.xAxes[0].scaleLabel.labelString = 'Horas'
          break;
        default:
          this.optionsLinear.scales.xAxes[0].scaleLabel.labelString = ''
          this.options.scales.xAxes[0].scaleLabel.labelString = ''
          break;
      }
      this.optionsLinear = Object.assign({}, this.optionsLinear);
      this.options = Object.assign({}, this.options);

    }, 
    fetchComplaintCategories(){
      this.axios
        .post("apidev/visitors/complaintCategories", {}, this.config)
        .then(response => {
          this.complaintCategories = response.data.categories;
          this.complaintCategories.forEach((data) => {
            data["dates"] = new Array(1).fill(0,0);
            data["days"]  = new Array(7).fill(0,0);
            data["hours"] = new Array(24).fill(0,0);
          })
        })
        .catch(error => {
          // removed console log
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    startDownloadAlerts(){
      let postData = {
        filtro_tipo: '',
        desde: this.desde,
        hasta: this.hasta,
        autoridades: this.Autoridades
      };

      this.axios
        .post("apidev/api/messages/alerts/",postData, this.config)
        .then(response => {
          let chats = []
          let groupChat = {}

          response.data.forEach(message => {
            if(groupChat.hasOwnProperty(message.id)){
              let text = '';
              if(message.user_type == "visitor"){
                text = `Visitor ${moment(message.message_date).format("DD/MM/YYYY hh:mm A")}: ${message.message}\n`
              }else{
                text = `Autoridad ${moment(message.message_date).format("DD/MM/YYYY hh:mm A")}: ${message.message}\n`
              }

              groupChat[message.id] += text;
            }else{
              let text = '';
              if(message.user_type == "visitor"){
                text = `Visitor ${moment(message.message_date).format("DD/MM/YYYY hh:mm A")}: ${message.message}\n`
              }else{
                text = `Autoridad ${moment(message.message_date).format("DD/MM/YYYY hh:mm A")}: ${message.message}\n`
              }

              groupChat[message.id] = text;
            }
          })

          Object.keys(groupChat).forEach(key => {
            const chat = {
              id: `F-${key}`,
              chat: groupChat[key]
            }
            chats.push(chat)
          });

          let alerts = [];
          this.downloadAlerts.forEach(alert => {
            const new_alert = {
              "Tipo de alerta": alert.tipo,
              Estado: alert.status,
              Sexo: alert.sex,
              Edad: alert.age,
              Nivel_estudios: alert.nivel_estudios,
              Fecha: moment(alert.fecha_alerta).format("DD/MM/YYYY hh:mm A"),
              id: `F-${alert.id}`,
              Nombre: alert.name,
              Apellido: alert.last_name,
              Comentario: alert.comentario_visitante,
              Reporte: alert.comentario_autoridad,
            };
            alerts.push(new_alert);
          });

          const alertsList = XLSX.utils.json_to_sheet(alerts);
          const chatList = XLSX.utils.json_to_sheet(chats);

          var wb = XLSX.utils.book_new();

          XLSX.utils.book_append_sheet(wb, alertsList, "Alertas");
          if(chats.length>0) { XLSX.utils.book_append_sheet(wb, chatList, "Chats"); }

          XLSX.writeFile(wb, "Alertas.xlsx");

          this.axios.post("apidev/api/binnacles/monitor/save/",{
              "module": "Reportes", 
              "action": "Descarga de alertas", 
              "observation": 'Información de las alertas',
              "email": localStorage.getItem("email")
            },
            this.config
          )
          .then(response => {
            //// removed console log
          })
          .catch(error => {
            //// removed console log
          });
        })
        .catch(error => {
          // removed console log
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.errored = true;
        })
    },

    startDownloadComplaint(){
      this.axios.post("apidev/api/binnacles/monitor/save/",{
          "module": "Reportes", 
          "action": "Descarga de denuncias", 
          "observation": 'Información de las denuncias',
          "email": localStorage.getItem("email")
        },
        this.config
      )
      .then(response => {
        //// removed console log
      })
      .catch(error => {
        //// removed console log
      });
    },

    change_table() {
      this.Autoridades = this.autoridadesGraph;
      this.filterAlertsData(this.selected);
    },

    getAlertTypes() {
      this.axios
        .get("apidev/api/alerts/getall/types/", this.config)
        .then(response => {
          this.respuesta = response.data;
          response.data.forEach(row => {
            this.AlertCategorys.push(row.tipo_alerta);
          });
        });
    },

    getComplaintsType() {
      this.axios
        .get("apidev/visitors/complaint/FileType", this.config)
        .then(response => {
          this.respuesta = response.data;
          response.data.forEach(row => {
            if (row.file_type == "video/mp4") {
              this.ComplaintCategorys.push([row.file_type, "VIDEO"]);
            }
            if (row.file_type == "audio/mpeg") {
              this.ComplaintCategorys.push([row.file_type, "AUDIO"]);
            }
            if (row.file_type == "image/jpeg") {
              this.ComplaintCategorys.push([row.file_type, "IMAGEN"]);
            }
          });
        });
    },

    getAlertsData() {
      this.text = "ALERTAS";
      this.AlertCharts = true;
      this.ComplaintCharts = false;
      this.etiquetas = [];
      this.datasets = [];

      this.etiquetas2 = [];
      this.datasets2 = [];
      this.data2 = [];

      this.etiquetas3 = [];
      this.datasets3 = [];
      this.data3 = [];

      this.abiertas = [];
      this.asignadas = [];
      this.atendidas = [];

      this.filtro_tipo = [];
      this.h = 0;
      this.m = 0;
      this.arrayAge = [0, 0, 0, 0, 0, 0, 0, 0];
      let postData = {
        desde: this.desde,
        hasta: this.hasta,
        autoridades: this.Autoridades
      };
      this.axios
        .post("apidev/api/alerts/getall/bystatus/", postData)
        .then(response => {
          this.downloadAlerts = response.data;
          this.info = response.data.length;
          this.respuesta = response.data;

          /*** SEXO ***/
          response.data.forEach(row => {
            if (row.sex === "H") {
              this.h++;
            } else {
              this.m++;
            }
            this.hombres = Math.round((this.h * 100) / response.data.length);
            this.mujeres = Math.round((this.m * 100) / response.data.length);
          });
          /*** FIN SEXO ***/

          /*** GRÁFICA DE STATUS ***/

          /* ARRAY DE ETIQUETAS */
          response.data.forEach(row => {
            /* FECHAS */
            if (!this.etiquetas.includes(row.fecha_alerta.split("T")[0])) {
              this.etiquetas.push(row.fecha_alerta.split("T")[0]);
              this.abiertas.push(0);
              this.asignadas.push(0);
              this.atendidas.push(0);
            }
            if (!this.filtro_tipo.includes(row.tipo)) {
              this.filtro_tipo.push(row.tipo);
            }
            /* FECHAS */

            /* EDADES */
            if (!this.etiquetas2.includes(row.age)) {
              this.etiquetas2.push(row.age);
              this.data2.push(0);
            }
            /* EDADES */

            /*  NIVEL */
            if (!this.etiquetas3.includes(row.nivel_estudios)) {
              this.etiquetas3.push(row.nivel_estudios);
              this.data3.push(0);
            }
            /* NIVEL */
          });

          /* FIN ARRAY DE ETIQUETAS */

          /* CONTEO DE COINCIDENCIAS */
          response.data.forEach(row => {
            /* COINCIDENCIA DE FECHAS */
            for (let i = 0; i < this.etiquetas.length; i++) {
              if (
                this.etiquetas[i] === row.fecha_alerta.split("T")[0] &&
                row.status === "ABIERTA"
              ) {
                this.abiertas[i] = this.abiertas[i] + 1;
              }
              if (
                this.etiquetas[i] === row.fecha_alerta.split("T")[0] &&
                row.status === "ASIGNADA"
              ) {
                this.asignadas[i] = this.asignadas[i] + 1;
              }
              if (
                this.etiquetas[i] === row.fecha_alerta.split("T")[0] &&
                row.status === "ATENDIDA"
              ) {
                this.atendidas[i] = this.atendidas[i] + 1;
              }
            }
            /* COINCIDENCIA DE FECHAS */

            /* COINCIDENCIA DE EDADES */

            this.filterAge(row.age);

            for (let i = 0; i < this.etiquetas2.length; i++) {
              if (this.etiquetas2[i] === row.age) {
                this.data2[i] = this.data2[i] + 1;
              }
              //this.filterAge(this.etiquetas2[i],this.data2[i],row.age)
            }
            /* COINCIDENCIA DE EDADES */

            /* COINCIDENCIA DE ESTUDIOS */
            for (let i = 0; i < this.etiquetas3.length; i++) {
              if (this.etiquetas3[i] === row.nivel_estudios) {
                this.data3[i] = this.data3[i] + 1;
              }
            }
            /* COINCIDENCIA DE ESTUDIOS */
          });
          /* FIN CONTEO DE COINCIDENCIAS */

          /* DATASETS */

          this.datasets2 = [
            {
              label: "< 18",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[0]]
            },
            {
              label: "18 a 25",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[1]]
            },
            {
              label: "26 a 30",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[2]]
            },
            {
              label: "31 a 35",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[3]]
            },
            {
              label: "36 a 40",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[4]]
            },
            {
              label: "41 a 45",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[5]]
            },

            {
              label: "46 a 50",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[6]]
            },
            {
              label: "50 +",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[7]]
            }
          ];
          /*
          for (let i = 0; i < this.etiquetas2.length; i++) {
            this.datasets2.push({
              label: this.etiquetas2[i] + " años",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.data2[i]]
            });
          }*/

          for (let i = 0; i < this.etiquetas3.length; i++) {
            this.datasets3.push({
              label: this.etiquetas3[i],
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.data3[i]]
            });
          }
          this.datasets = [
            {
              label: "ABIERTA",
              borderColor: "rgba(255,0,1,0.3)",
              pointBackgroundColor: "rgba(255,0,1)",
              borderWidth: 1,
              pointBorderColor: "white",
              backgroundColor: "rgba(255,0,1,0.3)",
              data: this.abiertas
            },
            {
              label: "ASIGNADA",
              borderColor: "rgba(255,109,13,0.3)",
              pointBackgroundColor: "rgba(255,109,13)",
              borderWidth: 1,
              pointBorderColor: "white",
              backgroundColor: "rgba(255,109,13,.3)",
              data: this.asignadas
            },
            {
              label: "ATENDIDA",
              borderColor: "rgba(75,255,0,0.3)",
              pointBackgroundColor: "rgba(75,255,0)",
              borderWidth: 1,
              pointBorderColor: "white",
              backgroundColor: "rgba(75,255,0,0.3)",
              data: this.atendidas
            }
          ];
          /* DATASETS */

          this.fillData();
        });
    },

    /*filterAlertsData: function(event) {*/
    filterAlertsData(event) {
      this.optionsLinear.scales.yAxes[0].scaleLabel.labelString = 'Alertas'
      this.options.scales.yAxes[0].scaleLabel.labelString = 'Alertas'
      this.updateOptionChart();

      this.text = "ALERTAS";
      this.selected = "";
      this.AlertCharts = true;
      this.ComplaintCharts = false;
      this.etiquetas = [];
      this.datasets = [];

      this.etiquetas2 = [];
      this.datasets2 = [];
      this.data2 = [];

      this.etiquetas3 = [];
      this.datasets3 = [];
      this.data3 = [];

      this.abiertas = [];
      this.asignadas = [];
      this.atendidas = [];

      this.abiertasByDay = [0, 0, 0, 0, 0, 0, 0];
      this.asignadasByDay = [0, 0, 0, 0, 0, 0, 0];
      this.atendidasByDay = [0, 0, 0, 0, 0, 0, 0];

      this.abiertasByHours.fill(0,0)
      this.asignadasByHours.fill(0,0)
      this.atendidasByHours.fill(0,0)

      this.filtro_tipo = [];
      this.h = 0;
      this.m = 0;
      this.arrayAge = [0, 0, 0, 0, 0, 0, 0, 0];
      let postData = {
        filtro_tipo: event,
        desde: this.desde,
        hasta: this.hasta,
        autoridades: this.Autoridades
      };
      this.axios
        .post("apidev/api/alerts/getall/bystatus/", postData)
        .then(response => {
          this.info = response.data.length;
          this.downloadAlerts = response.data;
          this.respuesta = response.data;
          /*** SEXO ***/
          response.data.forEach(row => {
            if (row.sex === "H") {
              this.h++;
            } else {
              this.m++;
            }
            this.hombres = Math.round((this.h * 100) / response.data.length);
            this.mujeres = Math.round((this.m * 100) / response.data.length);
          });
          /*** FIN SEXO ***/

          /*** GRÁFICA DE STATUS ***/

          /* ARRAY DE ETIQUETAS */
          response.data.forEach(row => {
            /* FECHAS */
            if (!this.etiquetas.includes(row.fecha_alerta.split("T")[0])) {
              this.etiquetas.push(row.fecha_alerta.split("T")[0]);
              this.abiertas.push(0);
              this.asignadas.push(0);
              this.atendidas.push(0);
            }

            if (!this.filtro_tipo.includes(row.tipo)) {
              this.filtro_tipo.push(row.tipo);
            }
            /* FECHAS */

            /* EDADES */
            if (!this.etiquetas2.includes(row.age)) {
              this.etiquetas2.push(row.age);
              this.data2.push(0);
            }
            /* EDADES */

            /*  NIVEL */
            if (!this.etiquetas3.includes(row.nivel_estudios)) {
              this.etiquetas3.push(row.nivel_estudios);
              this.data3.push(0);
            }
            /* NIVEL */
          });

          /* FIN ARRAY DE ETIQUETAS */

          /* CONTEO DE COINCIDENCIAS */
          response.data.forEach(row => {
            /* COINCIDENCIA DE FECHAS */
            for (let i = 0; i < this.etiquetas.length; i++) {
              if (
                this.etiquetas[i] === row.fecha_alerta.split("T")[0] &&
                row.status === "ABIERTA"
              ) {
                this.abiertas[i] = this.abiertas[i] + 1;
              }
              if (
                this.etiquetas[i] === row.fecha_alerta.split("T")[0] &&
                row.status === "ASIGNADA"
              ) {
                this.asignadas[i] = this.asignadas[i] + 1;
              }
              if (
                this.etiquetas[i] === row.fecha_alerta.split("T")[0] &&
                (row.status === "ATENDIDA" || row.status === "CERRADA")
              ) {
                this.atendidas[i] = this.atendidas[i] + 1;
              }
            }
            /* COINCIDENCIA DE FECHAS */

            /* COINCIDENCIA DE days */
            for (let i = 0; i < this.etiquetasByDay.length; i++) {
              let day = moment(row.fecha_alerta).day();
              if (
                this.etiquetasByDay[i] === this.stringDay[day] &&
                row.status === "ABIERTA"
              ) {
                this.abiertasByDay[i] = this.abiertasByDay[i] + 1;
              }
              if (
                this.etiquetasByDay[i] === this.stringDay[day] &&
                row.status === "ASIGNADA"
              ) {
                this.asignadasByDay[i] = this.asignadasByDay[i] + 1;
              }
              if (
                this.etiquetasByDay[i] === this.stringDay[day] &&
                (row.status === "ATENDIDA" || row.status === "CERRADA")
              ) {
                this.atendidasByDay[i] = this.atendidasByDay[i] + 1;
              }
            }
            /* COINCIDENCIA DE days */

            this.filterByHours(row);
            this.filterAge(row.age);

            /* COINCIDENCIA DE EDADES */
            for (let i = 0; i < this.etiquetas2.length; i++) {
              //alert(this.etiquetas2[i]+'='+row.age+'?')

              if (this.etiquetas2[i] === row.age) {
                //alert(this.data2[i])
                this.data2[i] = this.data2[i] + 1;
                //alert(this.data2[i])
              }
            }
            /* COINCIDENCIA DE EDADES */

            /* COINCIDENCIA DE ESTUDIOS */
            for (let i = 0; i < this.etiquetas3.length; i++) {
              //alert(this.etiquetas2[i]+'='+row.age+'?')
              if (this.etiquetas3[i] === row.nivel_estudios) {
                //alert(this.data2[i])
                this.data3[i] = this.data3[i] + 1;
                //alert(this.data2[i])
              }
            }
            /* COINCIDENCIA DE ESTUDIOS */
          });
          /* FIN CONTEO DE COINCIDENCIAS */

          /* DATASETS */

          this.datasets2 = [
            {
              label: "< 18",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[0]]
            },
            {
              label: "18 a 25",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[1]]
            },
            {
              label: "26 a 30",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[2]]
            },
            {
              label: "31 a 35",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[3]]
            },
            {
              label: "36 a 40",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[4]]
            },
            {
              label: "41 a 45",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[5]]
            },

            {
              label: "46 a 50",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[6]]
            },
            {
              label: "50 +",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[7]]
            }
          ];
          /*
          for (let i = 0; i < this.etiquetas2.length; i++) {
            this.datasets2.push({
              label: this.etiquetas2[i] + " años",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.data2[i]]
            });
          }*/

          for (let i = 0; i < this.etiquetas3.length; i++) {
            this.datasets3.push({
              label: this.etiquetas3[i],
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.data3[i]]
            });
          }

          if (this.Autoridades === true) {
            switch(this.historyGraph){
              case 'fechas':
                this.datasets = [
                  this.initObjectByAlert('ABIERTA',"rgba(255,0,1,0.3)","rgba(255,0,1)","rgba(255,0,1,0.3)",this.abiertas),
                  this.initObjectByAlert('ASIGNADA',"rgba(255,109,13,0.3)","rgba(255,109,13)","rgba(255,109,13,.3)",this.asignadas),
                  this.initObjectByAlert('ATENDIDA',"rgba(75,255,0,0.3)","rgba(75,255,0)","rgba(75,255,0,0.3)",this.atendidas),
                ]
                break;
              case 'dias':
                this.etiquetas = this.etiquetasByDay;
                this.datasets = [
                  this.initObjectByAlert('ABIERTA',"rgba(255,0,1,0.3)","rgba(255,0,1)","rgba(255,0,1,0.3)",this.abiertasByDay),
                  this.initObjectByAlert('ASIGNADA',"rgba(255,109,13,0.3)","rgba(255,109,13)","rgba(255,109,13,.3)",this.asignadasByDay),
                  this.initObjectByAlert('ATENDIDA',"rgba(75,255,0,0.3)","rgba(75,255,0)","rgba(75,255,0,0.3)",this.atendidasByDay)
                ]
                break;
              case 'Lunes':
              case 'Martes':
              case 'Miercoles':
              case 'Jueves':
              case 'Viernes':
              case 'Sabado':
              case 'Domingo':
                let hours = []
                for(let i=0; i<=23; i++) hours[i] = i;

                this.etiquetas = hours;
                this.datasets = [
                  this.initObjectByAlert('ABIERTA',"rgba(255,0,1,0.3)","rgba(255,0,1)","rgba(255,0,1,0.3)",this.abiertasByHours),
                  this.initObjectByAlert('ASIGNADA',"rgba(255,109,13,0.3)","rgba(255,109,13)","rgba(255,109,13,.3)",this.asignadasByHours),
                  this.initObjectByAlert('ATENDIDA',"rgba(75,255,0,0.3)","rgba(75,255,0)","rgba(75,255,0,0.3)",this.atendidasByHours)
                ]
                break;
              default:
                break;
            }
          } else {
            switch(this.historyGraph){
              case 'fechas':
                this.datasets = [
                  this.initObjectByAlert('ABIERTA',"rgba(255,0,1,0.3)","rgba(255,0,1)","rgba(255,0,1,0.3)",this.abiertas),
                  this.initObjectByAlert('CERRADA',"rgba(75,255,0,0.3)","rgba(75,255,0)","rgba(75,255,0,0.3)",this.atendidas),
                ]
                break;
              case 'dias':
                this.etiquetas = this.etiquetasByDay;
                this.datasets = [
                  this.initObjectByAlert('ABIERTA',"rgba(255,0,1,0.3)","rgba(255,0,1)","rgba(255,0,1,0.3)",this.abiertasByDay),
                  this.initObjectByAlert('CERRADA',"rgba(75,255,0,0.3)","rgba(75,255,0)","rgba(75,255,0,0.3)",this.atendidasByDay)
                ]
                break;
              case 'Lunes':
              case 'Martes':
              case 'Miercoles':
              case 'Jueves':
              case 'Viernes':
              case 'Sabado':
              case 'Domingo':
                let hours = []
                for(let i=0; i<=23; i++) hours[i] = i;

                this.etiquetas = hours;
                this.datasets = [
                  this.initObjectByAlert('ABIERTA',"rgba(255,0,1,0.3)","rgba(255,0,1)","rgba(255,0,1,0.3)",this.abiertasByHours),
                  this.initObjectByAlert('ATENDIDA',"rgba(75,255,0,0.3)","rgba(75,255,0)","rgba(75,255,0,0.3)",this.atendidasByHours)
                ]
                break;
              default:
                break;
            }
          }
          /* DATASETS */

          this.fillData();
        });
    },

    getComplaintsData() {
      this.optionsLinear.scales.yAxes[0].scaleLabel.labelString = 'Denuncias'
      this.options.scales.yAxes[0].scaleLabel.labelString = 'Denuncias'
      this.updateOptionChart();
      this.text = "DENUNCIAS";
      this.selected = "";
      this.AlertCharts = false;
      this.ComplaintCharts = true;
      this.etiquetas = [];
      this.datasets = [];
      this.Infraestructura = [];
      this.ambiente = [];
      this.Movilidad = [];
      this.civil = [];
      this.Recreacion = [];
      this.Salud = [];
      this.Seguridad = [];
      this.filtro_tipo = [];

      this.InfraestructuraByDay = [0, 0, 0, 0, 0, 0, 0];
      this.ambienteByDay = [0, 0, 0, 0, 0, 0, 0];
      this.MovilidadByDay = [0, 0, 0, 0, 0, 0, 0];
      this.civilByDay = [0, 0, 0, 0, 0, 0, 0];
      this.RecreacionByDay = [0, 0, 0, 0, 0, 0, 0];
      this.SaludByDay = [0, 0, 0, 0, 0, 0, 0];
      this.SeguridadByDay = [0, 0, 0, 0, 0, 0, 0];

      this.InfraestructuraByHours.fill(0,0);
      this.ambienteByHours.fill(0,0);
      this.MovilidadByHours.fill(0,0);
      this.civilByHours.fill(0,0);
      this.RecreacionByHours.fill(0,0);
      this.SaludByHours.fill(0,0);
      this.SeguridadByHours.fill(0,0);

      this.etiquetas2 = [];
      this.datasets2 = [];
      this.data2 = [];

      this.etiquetas3 = [];
      this.datasets3 = [];
      this.data3 = [];

      this.h = 0;
      this.m = 0;

      this.arrayAge = [0, 0, 0, 0, 0, 0, 0, 0];
      let postData = {
        desde: this.desde,
        hasta: this.hasta,
        autoridades: this.Autoridades
      };

      this.complaintCategories.forEach((data) => {
        data["dates"] = new Array(1).fill(0,0);
        data["days"]  = new Array(7).fill(0,0);
        data["hours"] = new Array(24).fill(0,0);
      })
      this.axios
        .post("apidev/visitors/complaint/complaintReport/", postData)
        .then(response => {
          this.downloadComplaints = response.data;
          this.info = response.data.length;

          /*** SEXO ***/
          response.data.forEach(row => {
            if (row.sex === "H") {
              this.h++;
            } else {
              this.m++;
            }
            this.hombres = Math.round((this.h * 100) / response.data.length);
            this.mujeres = Math.round((this.m * 100) / response.data.length);
          });
          /*** FIN SEXO ***/

          response.data.forEach(row => {
            if (!this.etiquetas.includes(row.fecha_alerta.split("T")[0])) {
              this.etiquetas.push(row.fecha_alerta.split("T")[0]);
              this.Infraestructura.push(0);
              this.ambiente.push(0);
              this.Movilidad.push(0);
              this.civil.push(0);
              this.Recreacion.push(0);
              this.Salud.push(0);
              this.Seguridad.push(0);
            }
            if (!this.filtro_tipo.includes(row.tipo)) {
              this.filtro_tipo.push(row.tipo);
            }

            /* EDADES */
            if (!this.etiquetas2.includes(row.age)) {
              this.etiquetas2.push(row.age);
              this.data2.push(0);
            }
            /* EDADES */

            /*  NIVEL */
            if (!this.etiquetas3.includes(row.nivel_estudios)) {
              this.etiquetas3.push(row.nivel_estudios);
              this.data3.push(0);
            }
          });

          this.complaintCategories.forEach((complaint) => {
            complaint.dates = new Array(this.etiquetas.length).fill(0,0);
          });

          response.data.forEach(row => {
            for (let i = 0; i < this.etiquetas.length; i++) {
              this.complaintCategories.forEach((complaint) => {
                if(
                  this.etiquetas[i] === row.fecha_alerta.split("T")[0] &&
                  row.status === complaint.name
                ){
                  complaint.dates[i] = complaint.dates[i] + 1;  
                }
              });
            }

            for (let i = 0; i < this.etiquetasByDay.length; i++) {
              let day = moment(row.fecha_alerta).day();
              this.complaintCategories.forEach((complaint) => {
                if(
                  this.etiquetasByDay[i] === this.stringDay[day] &&
                  row.status === complaint.name
                ){
                  complaint.days[i] = complaint.days[i] + 1;  
                }
              });
            }

            this.filterComplaintsByHours(row)
            /* COINCIDENCIA DE EDADES */

            this.filterAge(row.age);

            for (let i = 0; i < this.etiquetas2.length; i++) {
              //alert(this.etiquetas2[i]+'='+row.age+'?')
              if (this.etiquetas2[i] === row.age) {
                //alert(this.data2[i])
                this.data2[i] = this.data2[i] + 1;
                //alert(this.data2[i])
              }
            }
            /* COINCIDENCIA DE EDADES */

            /* COINCIDENCIA DE ESTUDIOS */
            for (let i = 0; i < this.etiquetas3.length; i++) {
              //alert(this.etiquetas2[i]+'='+row.age+'?')
              if (this.etiquetas3[i] === row.nivel_estudios) {
                //alert(this.data2[i])
                this.data3[i] = this.data3[i] + 1;
                //alert(this.data2[i])
              }
            }
            /* COINCIDENCIA DE ESTUDIOS */
          });

          /* DATASETS */

          this.datasets2 = [
            {
              label: "< 18",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[0]]
            },
            {
              label: "18 a 25",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[1]]
            },
            {
              label: "26 a 30",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[2]]
            },
            {
              label: "31 a 35",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[3]]
            },
            {
              label: "36 a 40",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[4]]
            },
            {
              label: "41 a 45",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[5]]
            },

            {
              label: "46 a 50",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[6]]
            },
            {
              label: "50 +",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[7]]
            }
          ];

          for (let i = 0; i < this.etiquetas3.length; i++) {
            this.datasets3.push({
              label: this.etiquetas3[i],
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.data3[i]]
            });
          }

          switch(this.historyGraph){
            case 'fechas':
              this.complaintCategories.forEach((data) => {
                this.datasets.push(this.initObjectByComplaints(data.name,  data.dates));
              });
              break;
            case 'dias':
              this.etiquetas = this.etiquetasByDay;
              this.complaintCategories.forEach((data) => {
                this.datasets.push(this.initObjectByComplaints(data.name,  data.days));
              });
              break;
            case 'Lunes':
            case 'Martes':
            case 'Miercoles':
            case 'Jueves':
            case 'Viernes':
            case 'Sabado':
            case 'Domingo':
              let hours = []
              for(let i=0; i<=23; i++) hours[i] = i;

              this.etiquetas = hours;
              this.complaintCategories.forEach((data) => {
                this.datasets.push(this.initObjectByComplaints(data.name,  data.hours));
              });
              break;
            default:
              break;
          }
          /* FIN DATASETS */
          this.fillData();
        });
    },

    filterComplaintsData(event) {
      this.text = "DENUNCIAS";
      this.AlertCharts = false;
      this.ComplaintCharts = true;
      this.etiquetas = [];
      this.datasets = [];
      this.Infraestructura = [];
      this.ambiente = [];
      this.Movilidad = [];
      this.civil = [];
      this.Recreacion = [];
      this.Salud = [];
      this.Seguridad = [];
      this.filtro_tipo = [];

      this.etiquetas2 = [];
      this.datasets2 = [];
      this.data2 = [];

      this.etiquetas3 = [];
      this.datasets3 = [];
      this.data3 = [];

      this.h = 0;
      this.m = 0;

      this.arrayAge = [0, 0, 0, 0, 0, 0, 0, 0];
      let postData = {
        filtro_tipo: event,
        desde: this.desde,
        hasta: this.hasta,
        autoridades: this.Autoridades
      };

      this.complaintCategories.forEach((data) => {
        data["dates"] = new Array(1).fill(0,0);
        data["days"]  = new Array(7).fill(0,0);
        data["hours"] = new Array(24).fill(0,0);
      })

      this.axios
        .post("apidev/visitors/complaint/complaintReport/", postData)
        .then(response => {
          this.downloadComplaints = response.data;
          this.respuesta = response.data;
          this.info = response.data.length;

          /*** SEXO ***/
          response.data.forEach(row => {
            if (row.sex === "H") {
              this.h++;
            } else {
              this.m++;
            }
            this.hombres = Math.round((this.h * 100) / response.data.length);
            this.mujeres = Math.round((this.m * 100) / response.data.length);
          });
          /*** FIN SEXO ***/

          response.data.forEach(row => {
            if (!this.etiquetas.includes(row.fecha_alerta.split("T")[0])) {
              this.etiquetas.push(row.fecha_alerta.split("T")[0]);
              this.Infraestructura.push(0);
              this.ambiente.push(0);
              this.Movilidad.push(0);
              this.civil.push(0);
              this.Recreacion.push(0);
              this.Salud.push(0);
              this.Seguridad.push(0);
            }

            if (!this.filtro_tipo.includes(row.tipo)) {
              this.filtro_tipo.push(row.tipo);
            }

            /* EDADES */
            if (!this.etiquetas2.includes(row.age)) {
              this.etiquetas2.push(row.age);
              this.data2.push(0);
            }
            /* EDADES */

            /*  NIVEL */
            if (!this.etiquetas3.includes(row.nivel_estudios)) {
              this.etiquetas3.push(row.nivel_estudios);
              this.data3.push(0);
            }
          });

          this.complaintCategories.forEach((complaint) => {
            complaint.dates = new Array(this.etiquetas.length).fill(0,0);
          });

          response.data.forEach(row => {
            for (let i = 0; i < this.etiquetas.length; i++) {
              this.complaintCategories.forEach((complaint) => {
                if(
                  this.etiquetas[i] === row.fecha_alerta.split("T")[0] &&
                  row.status === complaint.name
                ){
                  complaint.dates[i] = complaint.dates[i] + 1;  
                }
              });
            }

            for (let i = 0; i < this.etiquetasByDay.length; i++) {
              let day = moment(row.fecha_alerta).day();
              this.complaintCategories.forEach((complaint) => {
                if(
                  this.etiquetasByDay[i] === this.stringDay[day] &&
                  row.status === complaint.name
                ){
                  complaint.days[i] = complaint.days[i] + 1;  
                }
              });
            }
            this.filterComplaintsByHours(row)

            /* COINCIDENCIA DE EDADES */

            this.filterAge(row.age);

            for (let i = 0; i < this.etiquetas2.length; i++) {
              //alert(this.etiquetas2[i]+'='+row.age+'?')
              if (this.etiquetas2[i] === row.age) {
                //alert(this.data2[i])
                this.data2[i] = this.data2[i] + 1;
                //alert(this.data2[i])
              }
            }
            /* COINCIDENCIA DE EDADES */

            /* COINCIDENCIA DE ESTUDIOS */
            for (let i = 0; i < this.etiquetas3.length; i++) {
              //alert(this.etiquetas2[i]+'='+row.age+'?')
              if (this.etiquetas3[i] === row.nivel_estudios) {
                //alert(this.data2[i])
                this.data3[i] = this.data3[i] + 1;
                //alert(this.data2[i])
              }
            }
            /* COINCIDENCIA DE ESTUDIOS */
          });

          /* DATASETS */

          this.datasets2 = [
            {
              label: "< 18",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[0]]
            },
            {
              label: "18 a 25",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[1]]
            },
            {
              label: "26 a 30",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[2]]
            },
            {
              label: "31 a 35",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[3]]
            },
            {
              label: "36 a 40",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[4]]
            },
            {
              label: "41 a 45",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[5]]
            },

            {
              label: "46 a 50",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[6]]
            },
            {
              label: "50 +",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.arrayAge[7]]
            }
          ];
          /*for (let i = 0; i < this.etiquetas2.length; i++) {
            this.datasets2.push({
              label: this.etiquetas2[i] + " años",
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.data2[i]]
            });
          }*/

          for (let i = 0; i < this.etiquetas3.length; i++) {
            this.datasets3.push({
              label: this.etiquetas3[i],
              borderColor: this.random_rgba(),
              pointBackgroundColor: this.random_rgba(),
              borderWidth: 1,
              pointBorderColor: "black",
              backgroundColor: this.random_rgba(),
              data: [this.data3[i]]
            });
          }

          switch(this.historyGraph){
            case 'fechas':
              this.datasets = [
                this.initObjectByComplaints('Infraestructura',  this.Infraestructura),
                this.initObjectByComplaints('Medio ambiente', this.ambiente),
                this.initObjectByComplaints('Movilidad', this.Movilidad),
                this.initObjectByComplaints('Protección civil', this.civil),
                this.initObjectByComplaints('Recreación', this.Recreacion),
                this.initObjectByComplaints('Salud', this.Salud),
                this.initObjectByComplaints('Seguridad', this.Seguridad)
              ]
              break;
            case 'dias':
              this.etiquetas = this.etiquetasByDay;
              this.datasets = [
                this.initObjectByComplaints('Infraestructura',  this.InfraestructuraByDay),
                this.initObjectByComplaints('Medio ambiente', this.ambienteByDay),
                this.initObjectByComplaints('Movilidad', this.MovilidadByDay),
                this.initObjectByComplaints('Protección civil', this.civilByDay),
                this.initObjectByComplaints('Recreación', this.RecreacionByDay),
                this.initObjectByComplaints('Salud', this.SaludByDay),
                this.initObjectByComplaints('Seguridad', this.SeguridadByDay)
              ]
              break;
            case 'Lunes':
            case 'Martes':
            case 'Miercoles':
            case 'Jueves':
            case 'Viernes':
            case 'Sabado':
            case 'Domingo':
              let hours = []
              for(let i=0; i<=23; i++) hours[i] = i;

              this.etiquetas = hours;
              this.datasets = [
                this.initObjectByComplaints('Infraestructura',  this.InfraestructuraByHours),
                this.initObjectByComplaints('Medio ambiente', this.ambienteByHours),
                this.initObjectByComplaints('Movilidad', this.MovilidadByHours),
                this.initObjectByComplaints('Protección civil', this.civilByHours),
                this.initObjectByComplaints('Recreación', this.RecreacionByHours),
                this.initObjectByComplaints('Salud', this.SaludByHours),
                this.initObjectByComplaints('Seguridad', this.SeguridadByHours)
              ]
              break;
            default:
              break;
          }
          /* FIN DATASETS */
          this.fillData();
        });
    },

    fillData() {
      this.datacollection = {
        labels: this.etiquetas,
        datasets: this.datasets
      };

      this.datacollection2 = {
        labels: ["Edades"],
        datasets: this.datasets2
      };

      this.datacollection3 = {
        labels: ["Nivel"],
        datasets: this.sort_datasets(this.datasets3)
      };
    },

    /* arreglar datasets de mayor a menor */
    sort_datasets(arr) {
      return arr.slice().sort(function(a, b) {
        return a.data - b.data;
      });
    },

    /* colores aleatorios */
    random_rgba() {
      var o = Math.round,
        r = Math.random,
        s = 255;
      return (
        "rgba(" + o(r() * s) + "," + o(r() * s) + "," + o(r() * s) + ",0.3)"
      );
    },

    /* cambio de tipo de gráfica */
    change_chart(type) {
      this.graficas.forEach(row => {
        if (row.type === type) {
          row.value = true;
        } else {
          row.value = false;
        }
      });
    },

    /* filtro de edades por rango */
    filterAge(age) {
      switch (true) {
        case age < 18:
          this.arrayAge[0]++;
          break;
        case age >= 18 && age <= 25:
          this.arrayAge[1]++;
          break;
        case age >= 26 && age <= 30:
          this.arrayAge[2]++;
          break;
        case age >= 31 && age <= 35:
          this.arrayAge[3]++;
          break;
        case age >= 36 && age <= 40:
          this.arrayAge[4]++;
          break;
        case age >= 41 && age <= 45:
          this.arrayAge[5]++;
          break;
        case age >= 46 && age <= 50:
          this.arrayAge[6]++;
          break;
        case age > 50:
          this.arrayAge[7]++;
          break;
      }
    },

    initObjectByAlert(label, borderColor, pointBackgroundColor, backgroundColor, data){
      let init = {
        label: label,
        borderColor: borderColor,
        pointBackgroundColor: pointBackgroundColor,
        borderWidth: 1,
        pointBorderColor: "white",
        backgroundColor: backgroundColor,
        data: data
      }

      return init;
    },

    filterByHours(data){
      for (let i = 0; i <= 23; i++) {
        let day = moment(data.fecha_alerta).day();
        let hour = moment(data.fecha_alerta).hours();
        //let date = moment(data.fecha_alerta).format("DD/MM/YYYY hh:mm A");
        if (
          this.historyGraph === this.stringDay[day] &&
          data.status === "ABIERTA" && i==hour
        ) {
          this.abiertasByHours[i] = this.abiertasByHours[i] + 1;
        }
        if (
          this.historyGraph === this.stringDay[day] &&
          data.status === "ASIGNADA" && i==hour
        ) {
          this.asignadasByHours[i] = this.asignadasByHours[i] + 1;
        }
        if (
          this.historyGraph === this.stringDay[day] && i==hour &&
          (data.status === "ATENDIDA" || data.status === "CERRADA")
        ) {
          this.atendidasByHours[i] = this.atendidasByHours[i] + 1;
        }
      }
    },


    initObjectByComplaints(label, data){
      let init = {
        label: label,
        borderColor: this.random_rgba(),
        pointBackgroundColor: this.random_rgba(),
        borderWidth: 1,
        pointBorderColor: "black",
        backgroundColor: this.random_rgba(),
        data: data
      }

      return init;
    },

    filterComplaintsByHours(data){
      for (let i = 0; i <= 23; i++) {
        let day = moment(data.fecha_alerta).day();
        let hour = moment(data.fecha_alerta).hours();
        let date = moment(data.fecha_alerta).format("DD/MM/YYYY hh:mm");
      
        this.complaintCategories.forEach((complaint) => {
          if(
            this.historyGraph === this.stringDay[day] &&
            data.status === complaint.name && i==hour
          ){
            complaint.hours[i] = complaint.hours[i] + 1;  
          }
        });
      }
    },
  }
};
</script>

<style>
</style>
